import { Reducer } from 'redux';
import {
  ApplicationFormActionTypes,
  ApplicationFormState,
  CREATE_PAGE_PROGRESS_MAP,
  UPDATE_PAGE_PROGRESS,
  GO_TO_PAGE_APPLICATION,
  REVIEW_APPLICATION_PAGE
} from './types';

import { WizardActionTypes, SUBMIT_APPLICATION_SUCCESS } from '../wizard/types';

export const initialState: ApplicationFormState = {
  pageNumber: 0,
  progressMap: {},
  reviewingApplication: false,
  values: {}
};

export const applicationFormReducer: Reducer<
  ApplicationFormState,
  ApplicationFormActionTypes | WizardActionTypes
> = (
  state = initialState,
  action: ApplicationFormActionTypes | WizardActionTypes
): ApplicationFormState => {
  switch (action.type) {
    case SUBMIT_APPLICATION_SUCCESS: {
      return { ...state, reviewingApplication: false };
    }
    case REVIEW_APPLICATION_PAGE: {
      const { values } = action;

      return {
        ...state,
        reviewingApplication: true,
        values
      };
    }
    case GO_TO_PAGE_APPLICATION: {
      const { pageNumber } = action;
      // we mark the current page as already visited
      const { pageNumber: currentPage, progressMap } = state;

      const currentPageProgress = { ...progressMap[currentPage] };
      const updatedProgressMap = {
        ...progressMap,
        [currentPage]: {
          ...currentPageProgress,
          visited: true
        }
      };

      return {
        ...state,
        reviewingApplication: false,
        pageNumber,
        progressMap: updatedProgressMap
      };
    }
    case CREATE_PAGE_PROGRESS_MAP: {
      const { resetPageProgress, pageFieldsIds } = action;
      const { progressMap, pageNumber } = state;

      if (progressMap[pageNumber] && !resetPageProgress) {
        return state;
      }

      // progress for this page doesn't exist
      const newProgress = { ...progressMap };
      const newFields = pageFieldsIds
        ? pageFieldsIds.reduce(
            (acc: ObjectKeyStringKeyValues, fieldId: string) => {
              acc[fieldId] = '';
              return acc;
            },
            {}
          )
        : {};
      const pageProgress = { fields: newFields, percentComplete: 0 };

      newProgress[pageNumber] = pageProgress;
      return { ...state, progressMap: newProgress };
    }
    case UPDATE_PAGE_PROGRESS: {
      const { formSyncErrors, pageNumber: actionPageNumber } = action;
      const { progressMap, pageNumber: statePageNumber } = state;

      // if action contains a pageNumber we use it, otherwise default to statePageNumber
      const currentPage = actionPageNumber || statePageNumber;

      if (!progressMap[currentPage]) {
        return state;
      }

      //progress for this page exists, so update it based on sync errors
      const pageProgress = { ...progressMap[currentPage] };
      Object.keys(pageProgress.fields).forEach(key => {
        //clear previous required values
        pageProgress.fields[key] = '';
      });

      if (formSyncErrors) {
        //set required fields based on sync errors
        Object.assign(pageProgress.fields, formSyncErrors);

        //if fields is empty object means we do not have errors
        pageProgress.percentComplete = Object.keys(pageProgress.fields).length
          ? ((Object.keys(pageProgress.fields).length -
              Object.keys(formSyncErrors).length) /
              Object.keys(pageProgress.fields).length) *
            100
          : 100;
      }

      const newProgressMap = {
        ...progressMap,
        [currentPage]: pageProgress
      };

      return {
        ...state,
        progressMap: newProgressMap
      };
    }
    default: {
      return state;
    }
  }
};

export default applicationFormReducer;
